import React from 'react';

var InfoCircle = function InfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1.54-14.872c0 .656-.496 1.184-1.152 1.184-.656 0-1.2-.528-1.2-1.184 0-.656.528-1.184 1.184-1.184.656 0 1.168.528 1.168 1.184zm-2.176 3.616h-.928V9.24h2.56c.368 0 .496.176.496.512v5.456c0 .336.128.48.384.48.192 0 .48-.112.608-.208l-.064 1.216c-.304.208-.832.4-1.408.4-.656 0-1.104-.192-1.36-.544-.208-.288-.288-.736-.288-1.248v-4.56z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

InfoCircle.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { InfoCircle as icon };
export default iconHandler(InfoCircle);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/InfoCircle.js
// module id = 604
// module chunks = 0